import { Cookies } from 'react-cookie';

import { MCTTimeLineChart } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapDetailTimeLineChartData = async (slug: string, type: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/v1/trap-activation-signals-timeline-chart/${type}/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as MCTTimeLineChart;
};
